import { CompSliderCore } from '../core/forms/slider/comp'

export const CompSlider = CompSliderCore
